import * as React from 'react';

import { get as userGet } from 'js/lib/user';

import { useConsumerMyPageHeader } from 'bundles/composable-page-header-consumer/contexts/ConsumerMyPageHeaderContext';
import DegreeLearnerOnConsumerDesktopMainNav from 'bundles/composable-page-header-consumer/main-nav-modules/desktop/DegreeLearnerOnConsumerDesktopMainNav';
import EnterpriseLearnerOnConsumerDesktopMainNav from 'bundles/composable-page-header-consumer/main-nav-modules/desktop/EnterpriseLearnerOnConsumerDesktopMainNav';
import LoggedInConsumerNoSubNavDesktopMainNav from 'bundles/composable-page-header-consumer/main-nav-modules/desktop/LoggedInConsumerNoSubNavDesktopMainNav';
import LoggedOutConsumerDesktopMainNav from 'bundles/composable-page-header-consumer/main-nav-modules/desktop/LoggedOutConsumerDesktopMainNav';
import DegreeLearnerOnConsumerMobileMainNav from 'bundles/composable-page-header-consumer/main-nav-modules/mobile/DegreeLearnerOnConsumerMobileMainNav';
import EnterpriseLearnerOnConsumerMobileMainNav from 'bundles/composable-page-header-consumer/main-nav-modules/mobile/EnterpriseLearnerOnConsumerMobileMainNav';
import LoggedInConsumerWithMetaNavLinksMobileMainNav from 'bundles/composable-page-header-consumer/main-nav-modules/mobile/LoggedInConsumerWithMetaNavLinksMobileMainNav';
import LoggedOutConsumerMobileMainNav from 'bundles/composable-page-header-consumer/main-nav-modules/mobile/LoggedOutConsumerMobileMainNav';
import DefaultConsumerPageHeaderProvider from 'bundles/composable-page-header-consumer/providers/DefaultConsumerPageHeaderProvider';
import LegacyGDPRBannerWrapper from 'bundles/composable-page-header/banners/LegacyGDPRBannerWrapper';
import GlobalPageHeaderContainer from 'bundles/composable-page-header/components/GlobalPageHeaderContainer';
import DefaultMetaNavigation from 'bundles/composable-page-header/components/meta-nav/DefaultMetaNavigation';
import { DEFAULT_META_NAV_HEIGHT } from 'bundles/composable-page-header/constants';
import GlobalPageHeaderStateProvider from 'bundles/composable-page-header/providers/GlobalPageHeaderStateProvider';

type Props = {
  /** If true, hides the meta navigation entirely and adjusts scroll offset */
  hideMetaNav?: boolean;
};

const AccountProfilePageHeader = ({ hideMetaNav = false }: Props) => {
  const { chosenEnterpriseProgram, chosenDegree } = useConsumerMyPageHeader();
  const user = userGet();

  const getDesktopNav = () => {
    if (user?.id && !!chosenEnterpriseProgram) {
      return EnterpriseLearnerOnConsumerDesktopMainNav;
    } else if (user?.id && !!chosenDegree) {
      return DegreeLearnerOnConsumerDesktopMainNav;
    } else if (user?.id) {
      return LoggedInConsumerNoSubNavDesktopMainNav;
    } else {
      return LoggedOutConsumerDesktopMainNav;
    }
  };
  const getMobileNav = () => {
    if (user?.id && !!chosenDegree) {
      return DegreeLearnerOnConsumerMobileMainNav;
    } else if (user?.id && !!chosenEnterpriseProgram) {
      return EnterpriseLearnerOnConsumerMobileMainNav;
    } else if (user?.id) {
      return LoggedInConsumerWithMetaNavLinksMobileMainNav;
    } else {
      return LoggedOutConsumerMobileMainNav;
    }
  };

  const DesktopNavComponent = getDesktopNav();
  const MobileNavComponent = getMobileNav();

  const metaNavComponent = hideMetaNav ? null : <DefaultMetaNavigation />;

  return (
    <GlobalPageHeaderContainer
      desktopMainNav={<DesktopNavComponent />}
      mobileMainNav={<MobileNavComponent />}
      metaNav={metaNavComponent}
      scrollMovementOffset={{
        desktop: !hideMetaNav ? DEFAULT_META_NAV_HEIGHT : undefined,
        mobile: 0,
      }}
      banners={[{ name: 'GDPRBanner', component: <LegacyGDPRBannerWrapper /> }]}
    />
  );
};

const AccountProfilePageHeaderWithProvider = ({ hideMetaNav = false }: Props) => {
  return (
    <GlobalPageHeaderStateProvider
      additionalDefaultPageHeaderHeight={!hideMetaNav ? DEFAULT_META_NAV_HEIGHT : undefined}
    >
      <DefaultConsumerPageHeaderProvider>
        <AccountProfilePageHeader hideMetaNav={hideMetaNav} />
      </DefaultConsumerPageHeaderProvider>
    </GlobalPageHeaderStateProvider>
  );
};

export default AccountProfilePageHeaderWithProvider;
